import { createApp } from 'vue'
import ResourcesApp from './components/resources/ResourcesApp.vue'

const el = document.getElementById('resources-app')

if (el && window.resourcesData) {
    createApp(ResourcesApp, { config: window.resourcesData }).mount(el)
}
